import { useRouter } from 'next/router'

import en from '@/locales/en'
import vi from '@/locales/vi'

export type Language = 'vi' | 'en'
export type TextLanguage = typeof en | typeof vi

type useLocaleTypes = {
  locale: string | undefined
  text: TextLanguage
  lang: Language
  getText: (lang: Language) => TextLanguage
}

const useLocale = (): useLocaleTypes => {
  const { locale } = useRouter()

  // Default to Vietnamese unless English is explicitly selected
  const text = locale === 'en' ? en : vi
  const lang: Language = locale === 'en' ? 'en' : 'vi'

  /**
   * Get the text objects based on the language youu specified
   * @param _lang languuage code
   * @returns en and vi constant objects
   */
  const getText = (_lang: string) => {
    return _lang === 'en' ? en : vi
  }

  return { locale, text, lang, getText }
}

export default useLocale
